import React, { useState, useEffect } from 'react';
import './App.css';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Gallery from './pages/Gallery';
import Tenders from './pages/Tenders';
import Events from './pages/Events';
import Committee from './pages/Committee';
import Location from './pages/Location';
import Donation from './pages/Donation';
import Contact from './pages/Contact';
import Download from './pages/download';
import Footer from './components/Footer';

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.pageYOffset > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const renderPage = () => {
    switch(currentPage) {
      case 'home': return <Home setCurrentPage={setCurrentPage} />;
      case 'about': return <About />;
      case 'gallery': return <Gallery />;
      case 'tenders': return <Tenders />;
      case 'events': return <Events setCurrentPage={setCurrentPage} />;
      case 'committee': return <Committee />;
      case 'location': return <Location />;
      case 'aaras-download': return <Download />;
      case 'donation': return <Donation />;
      case 'contact': return <Contact />;
      default: return <Home />;
    }
  };

  return (
    <LanguageProvider>
      <div className="App">
        <Navbar currentPage={currentPage} setCurrentPage={setCurrentPage} />
        <main>
          {renderPage()}
        </main>
        <Footer setCurrentPage={setCurrentPage} />
        
        {showScrollTop && (
          <button className="scroll-to-top" onClick={scrollToTop}>
            ↑
          </button>
        )}
      </div>
    </LanguageProvider>
  );
}

export default App;
